import CounterInput from './CounterInput';

export default CounterInput;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/forms/CounterInput/index.js